export default __webpack_public_path__ + "static/media/601.e4ee5dc7.png";